import { createFileRoute } from "@tanstack/react-router";
import HotelManualInfo from "@/pages/admin/HotelManualInfo";

export const Route = createFileRoute("/admin/hotels")({
  component: HotelManualInfo,
});
